import React from "react";
import classes from "./ResearchPlan.module.css";

const ResearchPlan = ({ sessionData }) => {
  // If there's no data yet, don't render anything
  if (!sessionData || !sessionData.research_plan) return null;

  // Safely extract queries
  let queries = [];
  if (Array.isArray(sessionData.research_plan.queries)) {
      queries = sessionData.research_plan.queries;
  } else if (Array.isArray(sessionData.research_plan)) {
      queries = sessionData.research_plan;
  }

  return (
    <div className={classes.card}>
      <div className={classes.header}>
        <h1 className={classes.title}>Research Plan (CP-2)</h1>
        <p className={classes.subtitle}>
          The AI has planned the following web searches. Tell the AI in the chat if you approve or want changes!
        </p>
      </div>

      <div className={classes.queryList}>
        {queries.length === 0 && (
          <p style={{ color: "#64748b", fontStyle: "italic", marginBottom: "15px" }}>
            The AI determined no external web research is needed. You can tell it to proceed in the chat!
          </p>
        )}

        {queries.map((q, index) => (
          <div key={index} className={classes.queryItem}>
            {/* <label className={classes.queryLabel}>Query {index + 1} ({q.source})</label> */}
            <label className={classes.queryLabel}>Query {index + 1}</label>
            <div className={classes.queryInput} style={{ background: "#f8fafc", padding: "12px", borderRadius: "6px", border: "1px solid #e2e8f0" }}>
              {q.query}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ResearchPlan;